import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EnvironmentService } from "@app/core/environment/environment.service";
import { Observable, EMPTY } from "rxjs";
import { Feature } from "./feature.model";
import { catchError, retry, shareReplay } from "rxjs/operators";
import { normalizePath } from "../utils";
import { SdkAnalyticsService } from "../services/sdk-analytics/sdk-analytics.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class FeatureToggleService {
  private baseUrl: string;
  private iServicesUri: string;
  private API_CACHE: number = 1;
  private API_ATTEMPTS: number = 3;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private _sdkAnalyticsService: SdkAnalyticsService,
    private router: Router,
  ) {
    const apiUrl =
      environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;
    this.iServicesUri = this.environmentService.envModel.iServicesUri;
    this.baseUrl = `${apiUrl}/user/features/iservices`;
  }

  fetchLoggedUserFeature(jwt: string): Observable<Feature> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${jwt}` });
    return this.http.get<Feature>(this.baseUrl, { headers }).pipe(
      retry(this.API_ATTEMPTS),
      catchError(() => {
        return EMPTY;
      }),
      shareReplay(this.API_CACHE)
    );
  }

  goToiServices(url?: string) {
    url = url ? document.location.origin + url : "";

    if (url.includes("localhost")) {
      url = url.replace("/iservices", "");
      url = url.replace("4200", "3000");
    }

    const token = localStorage.getItem("token");
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const iServicesURl = `${
      url || this.iServicesUri
    }?token=${token}&idConexao=${authUser.idConexao}&username=${authUser.name}`;

    if (this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('screen_view', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: 'iservices-redirect'
      });
    }

    window.open(iServicesURl, "_blank");
  }

  getiServicesLinks(param: string) {
    let iServicesURL = `/iservices${param}`;

    return iServicesURL;
  }

}
